import { ofType } from 'redux-observable';
import { debounceTime, switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import {
  PAGINATE_RENTAL_LIST_REQUEST,
  PAGINATE_RENTAL_LIST_SUCCESS,
  EPIC_ERROR,
} from 'Constants/redux';
import service from 'Api/service';

const paginateRentalListEpic = (action$) =>
  action$.pipe(
    ofType(PAGINATE_RENTAL_LIST_REQUEST),
    debounceTime(500),
    switchMap(({ params }) => {
      const {
        link,
        numberPer: per,
        status: filter,
        startDate,
        endDate,
        query,
        billingStatus: billing_status,
        salesperson,
        rentalStatus: rental_status,
        pickedStatus: picked_status,
        checkedInStatus: checked_in_status,
      } = params;

      return from(
        service.get(`${import.meta.env.VITE_API_DOMAIN}${link}`, {
          per,
          filter,
          start_date: startDate,
          end_date: endDate,
          query,
          billing_status,
          salesperson,
          rental_status,
          picked_status,
          checked_in_status,
          show_all: false,
        })
      ).pipe(
        map((response) => ({
          type: PAGINATE_RENTAL_LIST_SUCCESS,
          payload: {
            rentals: response.data.rentals,
            pagination: response.data.meta.pagination,
          },
        })),
        catchError((err) => {
          console.error('paginateRentalListEpic error', err);
          return of({ type: EPIC_ERROR });
        })
      );
    })
  );

export default paginateRentalListEpic;
